// extracted by mini-css-extract-plugin
export default {"wrapper":"Tips_style_wrapper__NNkxp","image":"Tips_style_image__7PuPG","dots":"Tips_style_dots__5Y+EH","active":"Tips_style_active__vj3r2","rotate":"Tips_style_rotate__ud5sk"};